import { render, staticRenderFns } from "./DisassembleScrapList.vue?vue&type=template&id=1b50581d"
import script from "./DisassembleScrapList.vue?vue&type=script&lang=js"
export * from "./DisassembleScrapList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports